var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2222 0.5H1.77778C0.791111 0.5 0 1.3 0 2.27778V14.7222C0 15.7 0.791111 16.5 1.77778 16.5H14.2222C15.2 16.5 16 15.7 16 14.7222V2.27778C16 1.3 15.2 0.5 14.2222 0.5ZM11.5556 9.38889H8.88889V12.0556C8.88889 12.5444 8.48889 12.9444 8 12.9444C7.51111 12.9444 7.11111 12.5444 7.11111 12.0556V9.38889H4.44444C3.95556 9.38889 3.55556 8.98889 3.55556 8.5C3.55556 8.01111 3.95556 7.61111 4.44444 7.61111H7.11111V4.94444C7.11111 4.45556 7.51111 4.05556 8 4.05556C8.48889 4.05556 8.88889 4.45556 8.88889 4.94444V7.61111H11.5556C12.0444 7.61111 12.4444 8.01111 12.4444 8.5C12.4444 8.98889 12.0444 9.38889 11.5556 9.38889Z",
    fill: "#5B80BA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.811cedfdcf8f9b68e2936c681d91d7bb.svg";
export { ForwardRef as ReactComponent };